import { G_activeTriggerElements } from "../../../utils/globals/globals";
import run from "../../animate/run";

/**
 * Pointer down (active)
 * @param {CustomEventProps} event
 */
const pointerdown = (event) => {
  const main = /** @type {MainClassProps} */ (event.details?.get("main"));

  G_activeTriggerElements.add(main);

  run(event, "enter", true);

}

export default pointerdown;